export default class Certification {
    public static certificationFromApi(certJSON: any): Certification {
        const certification: Certification = new Certification();
        certification.setAllFields(certJSON);
        return certification;
    }

    public id?: number;
    public name?: string;
    public visible?: boolean;

    private setAllFields(certJSON: any) {
        this.id = certJSON.id;
        this.name = certJSON.name;
        this.visible = certJSON.visible;
    }
}
